import { gql } from '@apollo/client';

export interface IHostResponse {
  hostOverview: {
    alias: string;
    group_id: number;
  };
}
export const HOST = gql`
  query hostData($id: Int!) {
    hostOverview(id: $id) {
      alias
      group_id
    }
  }
`;
